import React from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

// config
import { DEFAULT_QUERY_BUILDER } from "@src/config/query-builder";

// context
import { useMultiStepQuery } from "@src/contexts/multi-step-query-context";
import { useWarehouseContext } from "@src/contexts/warehouse-context";

function AddNodeButton() {
  const { updateQuery } = useWarehouseContext();
  const { updateMethodsQuerySidebar, updateMethodsNode } = useMultiStepQuery();

  function addNode() {
    updateQuery(DEFAULT_QUERY_BUILDER);
    updateMethodsNode.setNode(null); // set node to null
    updateMethodsQuerySidebar.open(true); // set mode to add node
  }

  return (
    <Button type="dashed" className="border-gray-300 border-r-[1px] px-[8px] ml-2" onClick={addNode}>
      Add node <PlusOutlined />
    </Button>
  );
}

export default AddNodeButton;
